module.exports = __webpack_public_path__ + "img/28.0b2c515c.png";